<template>
    <v-row justify="center">
        <v-dialog v-model="regionModal" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Add region</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-select
                                    item-value="code"
                                    item-text="name"
                                    :items="countries"
                                    label="Country"
                                    v-model="country"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-menu
                                    v-model="showToDateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            :value="formatDate(date)"
                                            label="Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date" @input="showToDateMenu = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="handleCloseClick">
                        Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="handleAddRegionClick">
                        Add
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import moment from 'moment'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    name: 'StationRegionModal',
    computed: {
        ...mapState('probe', ['activeProbe', 'regionModal']),
        ...mapState('country', ['countries']),
    },
    beforeDestroy() {
        this.setRegionModal(false)
    },
    async mounted() {
        if (!this.countries.length) {
            await this.fetchCountries()
        }
    },
    data() {
        return {
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            showFromDateMenu: false,
            showToDateMenu: false,
            country: {},
        }
    },

    methods: {
        ...mapMutations('probe', ['setRegionModal']),
        ...mapActions('probe', ['addProbeRegion', 'fetchProbe']),
        ...mapActions('country', ['fetchCountries']),

        async handleCloseClick() {
            await this.setRegionModal(false)
        },
        async handleAddRegionClick() {
            const payload = {
                probe_id: this.activeProbe.id,
                country: this.country,
                date: this.date,
            }
            await this.addProbeRegion(payload)
            await this.setRegionModal(false)
            await this.fetchProbe(this.$route.params.id)
        },
        formatDate(date) {
            if (date) {
                return moment(date).format('DD.MM.YYYY')
            }
            return '-'
        },
    },
}
</script>

<style scoped></style>
